import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { BrokerPortfolioTypesEnum, DashFeaturesEnum } from 'dash-common';
import {
  Button,
  Flex,
  ModalContext,
  TooltipWrapper,
  ViewerContext,
  useCheckIfSubscriptionFeatureActiveBroker,
} from 'dash-ui';

import { PortfolioListItemFragment } from 'gql/generated.graphql';
import {
  getPreviewPortfolioPropertyLink,
  getPreviewPortfolioLink,
} from 'common/helpers/portfolio';

export const ButtonsContainer = styled(Flex)`
  position: absolute;
  right: 0;
  z-index: 2;
`;

const PortfolioActionButtons = ({
  portfolio,
}: {
  portfolio: PortfolioListItemFragment;
}) => {
  const { t } = useTranslation();
  const { broker, profile } = useContext(ViewerContext);
  const { toggleModal, setPayload } = useContext(ModalContext);
  const isFolder = portfolio.type === BrokerPortfolioTypesEnum.FOLDER;
  const { checkFeatureAccess } = useCheckIfSubscriptionFeatureActiveBroker([
    DashFeaturesEnum.PORTFOLIO_CREATION_AND_SHARING,
  ]);

  return (
    <ButtonsContainer justifyContent="flex-end" mr={3} mt={3}>
      {portfolio.isAddedMediaKit && (
        <Button
          medium
          icon="backupTable"
          mr={2}
          onClick={(event) => {
            event.stopPropagation();
            if (checkFeatureAccess()) {
              setPayload({ portfolioId: portfolio._id });
              toggleModal(true, 'ManageMediaKitModal');
            }
          }}
        >
          {t('pages:mediaKit.manageMediaKit')}
        </Button>
      )}
      <Button
        square
        medium
        mr={2}
        icon="visibility"
        onClick={(e) => {
          e.stopPropagation();
          if (isFolder) {
            return window?.open(
              getPreviewPortfolioLink(portfolio, broker, profile)
            );
          } else {
            e.stopPropagation();
            window?.open(
              getPreviewPortfolioPropertyLink(portfolio, broker, profile),
              '_blank'
            );
          }
        }}
      />

      {!isFolder && (
        <TooltipWrapper
          content={t('pages:portfolioDetailsPage:labels:moveProperty')}
        >
          <Button
            medium
            square
            icon="driveFileMove"
            data-tooltip-id={`${portfolio._id}-move-property`}
            mr={2}
            iconProps={{ size: 20 }}
            onClick={(e) => {
              e.stopPropagation();
              if (checkFeatureAccess()) {
                setPayload({ selectedItems: [portfolio] });
                toggleModal(true, 'MovePropertyToFolderModal');
              }
            }}
          />
        </TooltipWrapper>
      )}
      <Button
        medium
        square
        icon="trash"
        colorVariation="danger"
        onClick={(e) => {
          e.stopPropagation();
          if (!checkFeatureAccess()) return;
          if (!isFolder) {
            toggleModal(true, 'RemovePropertyFromPortfolio');
            setPayload({
              portfolioId: portfolio._id,
            });
          } else {
            toggleModal(true, 'RemoveFolderFromPortfolio');
            setPayload({
              folderId: portfolio._id,
            });
          }
        }}
      />
    </ButtonsContainer>
  );
};

export default PortfolioActionButtons;
